import { render, staticRenderFns } from "./MtaPayment.vue?vue&type=template&id=e17d6b4e&scoped=true"
import script from "./MtaPayment.vue?vue&type=script&lang=js"
export * from "./MtaPayment.vue?vue&type=script&lang=js"
import style0 from "./MtaPayment.vue?vue&type=style&index=0&id=e17d6b4e&prod&lang=scss"
import style1 from "./MtaPayment.vue?vue&type=style&index=1&id=e17d6b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17d6b4e",
  null
  
)

export default component.exports